import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "attrs"];

/* eslint-disable react/no-danger */
import React, { useMemo, useState } from 'react';
import classnames from 'classnames';
import { Iconfont } from '@/baseComponents';
import './index.less';

const getTypeGroup = (type, columns = []) => {
  return columns.reduce((res = [], item = {}) => {
    const {
      fields = []
    } = item;
    fields.forEach((field = {}) => {
      const {
        productType,
        dataType = []
      } = field;

      if (productType === type) {
        let curr = dataType || [];
        curr = Array.isArray(curr) ? curr : [curr];
        res.push(curr);
      }
    });
    return res;
  }, []);
};

const getPartSource = (list = [], columns = [], flag = 1) => {
  return list.reduce((res = [], item = {}) => {
    const {
      planConfigLiabilityList = [],
      productType,
      productName,
      simpleRemark: productSampleDesc,
      sumInsuredValueStr: productSumInsuredValueStr
    } = item;
    const typeGroup = getTypeGroup(productType, columns); // console.log('typeGroup==>',typeGroup)

    if (typeGroup[0][0] === 'product') {
      if (flag === 3 && item.isOptional !== 'Y') {
        return res;
      }

      if (flag === 2 && item.isOptional !== 'N') {
        return res;
      }

      const curr = [];
      typeGroup.forEach((type = []) => {
        const strs = [];
        type.forEach(currType => {
          let str;

          switch (currType) {
            case 'productSampleDesc':
              str = `<div class="package-part">${productSampleDesc || ''}</div>`;
              break;

            case 'product':
              str = `<div class="package-part">${productName || ''}</div>`;
              break;

            case 'sumInsured':
            case 'limmit':
            case 'deductible':
              str = productSumInsuredValueStr || '';
              str = str.replace(/\d+\.{0,1}\d+/g, text => {
                const num = Number(text);

                if (Number.isNaN(num)) {
                  return text;
                }

                return num < 10000 ? `${num}` : `${num * 100 / 1000000}万`;
              });
              break;
          }

          str && strs.push(str);
        });
        const text = strs.join('');
        text && curr.push(text);
      });
      res.push(curr);
      return res;
    }

    planConfigLiabilityList.forEach((liability = {}) => {
      if (flag === 3 && item.isOptional !== 'Y' && liability.isOptional !== 'Y') {
        return;
      }

      if (flag === 2 && item.isOptional !== 'N' && liability.isOptional !== 'N') {
        return;
      }

      const {
        liabilityName,
        sumInsuredValueStr = '',
        simpleRemark
      } = liability;
      const curr = [];
      typeGroup.forEach((type = []) => {
        const strs = [];
        type.forEach(currType => {
          let str;

          switch (currType) {
            case 'liability':
              str = `<div class="package-part">${liabilityName || ''}</div>`;
              break;

            case 'liabilitySampleDesc':
              str = `<div class="package-part">${simpleRemark || ''}</div>`;
              break;

            case 'productSampleDesc':
              str = `<div class="package-part">${productSampleDesc || ''}</div>`;
              break;

            case 'product':
              str = `<div class="package-part">${productName || ''}</div>`;
              break;

            case 'sampleDesc':
              str = `<div class="package-part">${simpleRemark || ''}</div>`;
              break;

            case 'sumInsured':
            case 'limmit':
            case 'deductible':
              str = sumInsuredValueStr || '';
              str = str.replace(/\d+\.{0,1}\d+/g, text => {
                const num = Number(text);

                if (Number.isNaN(num)) {
                  return text;
                }

                return num < 10000 ? `${num}` : `${num * 100 / 1000000}万`;
              });
              break;
          }

          str && strs.push(str);
        });
        const text = strs.join('');
        text && curr.push(text);
      });
      res.push(curr);
    });
    return res;
  }, []);
};

const InsurancePlanDesc = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    maxLength = '',
    buttonText = '',
    showColumn = false,
    specialDesc = {},
    columns = [],
    dataSource = []
  } = attrs; // console.log('GuaranteeDutyprops==>',props)

  const [showMore, setShowMore] = useState(false);
  const source = useMemo(() => {
    const {
      serviceList = [],
      planConfigMainProductList = [],
      planConfigAdditionProductList = []
    } = dataSource;
    let res = [];
    res = res.concat(getPartSource(planConfigMainProductList, columns, 2));
    res = res.concat(getPartSource(planConfigAdditionProductList, columns, 2));
    serviceList.forEach((item = {}) => {
      const {
        serviceShowName,
        serviceDescription
      } = item;
      res.push([serviceShowName, serviceDescription]);
    });
    return res;
  }, [dataSource, columns]);
  const sourceKX = useMemo(() => {
    const {
      planConfigMainProductList = [],
      planConfigAdditionProductList = []
    } = dataSource;
    let res = [];
    res = res.concat(getPartSource(planConfigMainProductList, columns, 3));
    res = res.concat(getPartSource(planConfigAdditionProductList, columns, 3));
    return res;
  }, [dataSource, columns]);
  const data = useMemo(() => {
    if (showMore) {
      return source;
    }

    if (!maxLength) {
      return source;
    }

    return source.slice(0, maxLength);
  }, [maxLength, showMore, source]);
  const cls = classnames({
    'components-guarantee-duty-render': true,
    [className]: !!className
  });

  const onClickButton = () => setShowMore(!showMore);

  const renderColumns = () => {
    if (!showColumn) {
      return null;
    }

    const items = columns.map((item = {}, index) => {
      const {
        label
      } = item;
      const itemCls = classnames({
        'columns-item': true,
        main: index === 0
      });
      return /*#__PURE__*/React.createElement("div", {
        className: itemCls
      }, label);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "duty-columns"
    }, items);
  };

  const renderData = () => {
    const items = data.map((item = {}, index) => {
      const [title, desc] = item;
      const dangerouslySetInnerHTML = {
        __html: title
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "data-item",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "item-title",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
      }), /*#__PURE__*/React.createElement("div", {
        className: "item-desc"
      }, desc));
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "duty-data"
    }, items);
  };

  const renderIsOptionalData = () => {
    if (maxLength >= source.length + sourceKX.length || showMore || !maxLength) {
      const items = sourceKX.map((item = {}, index) => {
        const [title, desc] = item;
        const dangerouslySetInnerHTML = {
          __html: title
        };
        return /*#__PURE__*/React.createElement("div", {
          className: "data-item",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "item-title",
          dangerouslySetInnerHTML: dangerouslySetInnerHTML
        }), /*#__PURE__*/React.createElement("div", {
          className: "item-desc"
        }, desc));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "duty-data"
      }, /*#__PURE__*/React.createElement("h4", null, "\u53EF\u9009\u8D23\u4EFB"), items);
    }

    return null;
  };

  const renderDesc = () => {
    const {
      enable,
      value = []
    } = specialDesc;

    if (!enable) {
      return null;
    }

    if (data.length < source.length) {
      return null;
    }

    const items = value.map((item, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, item);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "duty-desc"
    }, items);
  };

  const renderButton = () => {
    if (!maxLength) {
      return null;
    }

    if (maxLength >= source.length) {
      return null;
    }

    const buttonCls = classnames({
      'duty-button': true,
      reverse: !!showMore
    });
    return /*#__PURE__*/React.createElement("div", {
      className: buttonCls,
      onClick: onClickButton
    }, /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, showMore ? '收起' : buttonText), /*#__PURE__*/React.createElement("div", {
      className: "icons"
    }, /*#__PURE__*/React.createElement(Iconfont, {
      className: "icon",
      type: "biansechakangengduo"
    }), /*#__PURE__*/React.createElement(Iconfont, {
      className: "icon",
      type: "biansechakangengduo"
    })));
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), renderColumns(), renderData(), renderDesc(), renderIsOptionalData(), renderButton());
});
export default InsurancePlanDesc;